export default {
    namespaced: true,

    state: {
        countries: {},
        subdomainCompany: {},
    },

    getters: {
        getCountries(state) {
            return state.countries
        },

        getSubdomainCompany(state) {
            return state.subdomainCompany
        },

        getCountryByGeolocation(state) {
            return state.countryFromIp
        },
    },

    mutations: {
        setCountries(state, countries) {
            state.countries = countries
        },

        setSubdomainCompany(state, subdomainCompany) {
            state.subdomainCompany = subdomainCompany
        },

        setCountryByGeolocation(state, id) {
            state.countryFromIp = id
        },
    },

    actions: {
        setCountries(Store, countries) {
            Store.commit('setCountries', countries)
        },

        setSubdomainCompany(Store, subdomainCompany) {
            Store.commit('setSubdomainCompany', subdomainCompany)
        },

        setCountryByGeolocation(Store, ip) {
            Store.commit('setCountryByGeolocation', ip)
        },
    },
}
